import { differenceInCalendarDays, isBefore, startOfDay } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { stateToTzMap } from '@ourbranch/state-to-tz-map';

export const isPastOrWithin7Days = (date, state) => {
  if (!date || !state) {
    return false;
  }
  const timezone = stateToTzMap[state];
  const dateStr = typeof date === 'string' ? date : date.toISOString().slice(0, 10);
  const today = startOfDay(utcToZonedTime(new Date(), timezone));
  const checkDateUtc = zonedTimeToUtc(`${dateStr} 00:00`, timezone);
  const checkDate = startOfDay(utcToZonedTime(checkDateUtc, timezone));
  const inPast = isBefore(checkDate, today);
  const diffDays = differenceInCalendarDays(checkDate, today);
  return inPast || (diffDays >= 0 && diffDays <= 7);
};

export const isEffectiveDateInPast = (date, state) => {
  if (!date || !state) {
    return false;
  }
  const timezone = stateToTzMap[state];
  const dateStr = typeof date === 'string' ? date : date.toISOString().slice(0, 10);
  const today = startOfDay(utcToZonedTime(new Date(), timezone));
  const checkDateUtc = zonedTimeToUtc(`${dateStr} 00:00`, timezone);
  const checkDate = startOfDay(utcToZonedTime(checkDateUtc, timezone));
  const daysDiff = differenceInCalendarDays(checkDate, today);
  return daysDiff <= 0;
};
